import { render, staticRenderFns } from "./imageUpTextDownMobile.vue?vue&type=template&id=3a83ae96&scoped=true"
import script from "./imageUpTextDownMobile.vue?vue&type=script&lang=js"
export * from "./imageUpTextDownMobile.vue?vue&type=script&lang=js"
import style0 from "./imageUpTextDownMobile.vue?vue&type=style&index=0&id=3a83ae96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a83ae96",
  null
  
)

export default component.exports